import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class ModalBox extends Vue {

  @Prop()
  private showStepper?: boolean;

  @Prop()
  private halfScreen?: boolean;

  @Prop()
  private fullScreen?: boolean;

  @Prop()
  private mostScreen?: boolean;

  mounted(): void {
    document.body.classList.add('modal-open');
  }

  unmounted(): void {
    document.body.classList.remove('modal-open');
  }

}

